import axios from 'axios'

let notice = {}
// 查询所有通知
notice.list = params => {
  return axios.get('/notice/find', {params})
}
// 发布通知
notice.publishNotice = params => {
  return axios.post('/notice/publish', params)
}
// 删除通知
notice.delNotice = params => {
  return axios.get('/notice/del', {params})
}
// 搜索
notice.search = params => {
  return axios.post('/notice/search', params)
}
export default notice



// WEBPACK FOOTER //
// ./src/api/notice.js